import React, {Component} from 'react'
import {
  Box,
  Heading,
  VStack,
  Grid,
  GridItem,
  Text,
  Card,
  CardBody,
  Stack,
  Stat,
  StatLabel,
  StatNumber,
  StatGroup,
  Icon,
  List,
  ListItem,
  ListIcon,
  HStack,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription
} from '@chakra-ui/react';
import { AddIcon, TimeIcon, CheckCircleIcon } from '@chakra-ui/icons';
import './BurgerWelcome.css'
import Sidebar from '../Sidebar/Sidebar';
import Navigation from '../../Navigation/Navigation';
import OnboardingTour from '../../../components/OnboardingTour';
import MobileMenu from '../MobileMenu/MobileMenu';
import Footer from '../../../components/Footer/Footer';
import colors from '../../../theme/colors';

class BurgerWelcome extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showOnboarding: false,
      isMobileMenuOpen: false
    }
  }

  componentDidMount() {
    // Load user suggestions to get stats
    if (this.props.loadSuggestions) {
      this.props.loadSuggestions();
    }

    // Show onboarding tour if not completed
    if (!this.props.state.onboardingCompleted) {
      this.setState({ showOnboarding: true })
    }
  }

  handleCompleteOnboarding = async () => {
    // Close the modal
    this.setState({ showOnboarding: false })

    // Call backend to mark onboarding as complete
    try {
      const response = await this.props.authenticatedFetch(`${process.env.REACT_APP_API_URL || ''}/complete-onboarding`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      })

      const data = await response.json()

      if (data.success) {
        // Update state to mark onboarding as completed
        if (this.props.onOnboardingComplete) {
          this.props.onOnboardingComplete()
        }
      }
    } catch (error) {
      console.error('Error completing onboarding:', error)
    }
  }

  handleOpenMobileMenu = () => {
    this.setState({ isMobileMenuOpen: true })
  }

  handleCloseMobileMenu = () => {
    this.setState({ isMobileMenuOpen: false })
  }

  componentWillUnmount() {
    // Ensure mobile menu is closed when component unmounts
    if (this.state.isMobileMenuOpen) {
      this.setState({ isMobileMenuOpen: false })
    }
  }
  render () {
    const suggestionCount = this.props.state.suggestions?.total || 0;
    
    return (
      <>
        <Grid templateColumns="repeat(24, 1fr)" bg="gray.50">
        {/* sidebar */}
        <GridItem
          as="aside"
          colSpan={{ base: 0, md: 4, lg: 3 }}
          display={{ base: "none", md: "block" }}
          bg="gray.50"
          minHeight={{ lg: '100vh' }}
          p={0}
        >
        <Sidebar
        getFeed = {this.props.getFeed}
        onRouteChange = {this.props.onRouteChange}
        userVersion = {this.props.state.userVersion}
        resetSuggestionsPage = {this.props.resetSuggestionsPage}
        onLogout = {this.props.onLogout}
        />
        </GridItem>
        <GridItem
        as="main"
        colSpan={{ base: 24, md: 20, lg: 21 }}
        p={{ base: "8px", md: "10px" }}
        display="flex"
        flexDirection="column"
        minHeight="100vh"
        >
        <Navigation
        state = {this.props.state}
        onRouteChange = {this.props.onRouteChange}
        getFeed = {this.props.getFeed}
        onVersionChange = {this.props.onVersionChange}
        onLogout = {this.props.onLogout}
        onOpenFeedback = {this.props.onOpenFeedback}
        onOpenMobileMenu = {this.handleOpenMobileMenu}
        />

        <Box p={{ base: "16px", md: "40px" }} flex="1">
          <Box maxW="1200px" mx="auto">
            <VStack spacing={8} align="stretch">
              <Box textAlign="center">
                <Heading as="h1" size="2xl" color={colors.primary.main} mb={2}>
                  Welkom terug, {this.props.state.username}!
                </Heading>
                <Text color="gray.600" fontSize="xl">
                  Wat wilt u vandaag doen?
                </Text>
              </Box>

              {/* Info Alert */}
              <Alert
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                textAlign="center"
                borderRadius="lg"
                py={6}
                bg="white"
                border="2px solid"
                borderColor="gray.400"
                shadow="md"
              >
                <AlertIcon boxSize="40px" mr={0} color={colors.primary.main} />
                <AlertTitle mt={4} mb={2} fontSize="lg" color="gray.800">
                  Welkom bij Demos!
                </AlertTitle>
                <AlertDescription maxWidth="lg" fontSize="md" color="gray.600">
                  In dit platform kun je je ideeën voor een betere samenleving
                  delen met vertegenwoordigers.
                </AlertDescription>
              </Alert>

              {/* What You Can Do */}
              <Card bg="white" shadow="lg" borderRadius="xl" border="1px solid" borderColor="gray.100">
                <CardBody>
                  <VStack align="start" spacing={4}>
                    <HStack>
                      <Icon as={CheckCircleIcon} color="green.500" boxSize={6} />
                      <Heading as="h3" size="md">
                        Wat je kunt doen met jouw account
                      </Heading>
                    </HStack>

                    <List spacing={3}>
                      <ListItem>
                        <HStack align="start">
                          <ListIcon as={CheckCircleIcon} color="green.500" mt={1} />
                          <Text>
                            <strong>Suggesties indienen</strong> - Deel je ideeën en voorstellen voor een betere samenleving
                          </Text>
                        </HStack>
                      </ListItem>
                      <ListItem>
                        <HStack align="start">
                          <ListIcon as={CheckCircleIcon} color="green.500" mt={1} />
                          <Text>
                            <strong>Jouw historie bekijken</strong> - Houd al jouw ingediende suggesties en hun status bij
                          </Text>
                        </HStack>
                      </ListItem>
                      <ListItem>
                        <HStack align="start">
                          <ListIcon as={CheckCircleIcon} color="green.500" mt={1} />
                          <Text>
                            <strong>Berichten ontvangen</strong> - Vertegenwoordigers kunnen reageren op jouw suggesties en met je communiceren
                          </Text>
                        </HStack>
                      </ListItem>
                      <ListItem>
                        <HStack align="start">
                          <ListIcon as={CheckCircleIcon} color="green.500" mt={1} />
                          <Text>
                            <strong>Privacy en controle</strong> - Jouw gegevens zijn veilig en je kunt jouw account op elk moment verwijderen via Instellingen
                          </Text>
                        </HStack>
                      </ListItem>
                    </List>
                  </VStack>
                </CardBody>
              </Card>

              {/* Privacy Notice */}
              <Alert status="success" borderRadius="lg" variant="left-accent">
                <AlertIcon />
                <Box>
                  <AlertTitle>Privacy en gegevens</AlertTitle>
                  <AlertDescription>
                    Uw suggesties worden alleen gedeeld met vertegenwoordigers.
                    Uw emailadres blijft privé en wordt niet getoond aan andere gebruikers.
                  </AlertDescription>
                </Box>
              </Alert>

              {/* Stats Card */}
              <Card bg="white" shadow="lg" borderRadius="xl" border="1px solid" borderColor="gray.100">
                <CardBody>
                  <StatGroup>
                    <Stat textAlign="center">
                      <StatLabel color="gray.600">Uw Suggesties</StatLabel>
                      <StatNumber fontSize="3xl" color={colors.primary.main}>
                        {suggestionCount}
                      </StatNumber>
                    </Stat>
                  </StatGroup>
                </CardBody>
              </Card>

              {/* Action Cards */}
              <Stack direction={{ base: "column", md: "row" }} spacing={6} justify="center">
                <Card
                  bg="white"
                  shadow="lg"
                  borderRadius="xl"
                  border="1px solid"
                  borderColor="gray.100"
                  cursor="pointer"
                  transition="transform 0.2s"
                  _hover={{ transform: 'translateY(-4px)', shadow: 'xl' }}
                  onClick={() => this.props.onRouteChange('suggestieIndienen')}
                  flex="1"
                >
                  <CardBody textAlign="center" p={8}>
                    <Icon as={AddIcon} boxSize={8} color={colors.primary.main} mb={4} />
                    <Heading size="md" mb={2} color="gray.700">
                      Suggestie Indienen
                    </Heading>
                    <Text color="gray.600">
                      Deel uw ideeën voor een betere samenleving
                    </Text>
                  </CardBody>
                </Card>

                <Card
                  bg="white"
                  shadow="lg"
                  borderRadius="xl"
                  border="1px solid"
                  borderColor="gray.100"
                  cursor="pointer"
                  transition="transform 0.2s"
                  _hover={{ transform: 'translateY(-4px)', shadow: 'xl' }}
                  onClick={() => this.props.onRouteChange('ingediendeSuggesties')}
                  flex="1"
                >
                  <CardBody textAlign="center" p={8}>
                    <Icon as={TimeIcon} boxSize={8} color="gray.500" mb={4} />
                    <Heading size="md" mb={2} color="gray.700">
                      Mijn Historie
                    </Heading>
                    <Text color="gray.600">
                      Bekijk uw ingediende suggesties en hun status
                    </Text>
                  </CardBody>
                </Card>
              </Stack>
            </VStack>
          </Box>
        </Box>

        <Footer onRouteChange={this.props.onRouteChange} />

        </GridItem>
        </Grid>

        {/* Onboarding Tour */}
        <OnboardingTour
          isOpen={this.state.showOnboarding}
          onClose={() => this.setState({ showOnboarding: false })}
          onComplete={this.handleCompleteOnboarding}
        />

        {/* Mobile Menu Drawer */}
        <MobileMenu
          isOpen={this.state.isMobileMenuOpen}
          onClose={this.handleCloseMobileMenu}
          onRouteChange={this.props.onRouteChange}
          userVersion={this.props.state.userVersion}
          resetSuggestionsPage={this.props.resetSuggestionsPage}
          onLogout={this.props.onLogout}
        />
      </>
    )
  }
}

export default BurgerWelcome